import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { DestroyRef } from '@angular/core';
/**
 * Was initially based on a custom solution found here: https://github.com/joostme/takeWhileAlive
 * Since angular has introduced DestroyRef and takeUntilDestroyed, now it is nothing but an alias for takeUntilDestroyed.
 */
export function takeWhileAlive(arg) {
  if (arg instanceof DestroyRef) return takeUntilDestroyed(arg);
  // NOTE: inject(DestroyRef) will return R3Injector instance for root-provided services.
  // R3Injector is not exported so we need to "soft guess" that we received a compatible object.
  if (arg && typeof arg.onDestroy === 'function') return takeUntilDestroyed(arg);
  return takeUntilDestroyed();
}
export function AutoUnsubscribe() {
  return target => {};
}